import { z } from 'zod/v4';
import { ROLE_KEYS } from '../../../permissions/contracts/index.js';

export const CreateCompanyJoinRequestBodySchema = z.object({
  companyId: z.string().min(1, 'Company ID is required'),
});

export type CreateCompanyJoinRequestBody = z.infer<
  typeof CreateCompanyJoinRequestBodySchema
>;

/** Roles an owner can grant when approving a join request. */
export const JOIN_REQUEST_ROLE_VALUES = [
  ROLE_KEYS.COMPANY_CREATOR,
  ROLE_KEYS.COMPANY_ADMIN,
] as const;

export const ApproveCompanyJoinRequestBodySchema = z.object({
  role: z.enum(JOIN_REQUEST_ROLE_VALUES),
});

export type ApproveCompanyJoinRequestBody = z.infer<
  typeof ApproveCompanyJoinRequestBodySchema
>;

export const CompanyJoinRequestParamsSchema = z.object({
  id: z.string().min(1, 'Join request ID is required'),
});

export type CompanyJoinRequestParams = z.infer<
  typeof CompanyJoinRequestParamsSchema
>;

export const CompanyJoinRequestResponseSchema = z.object({
  id: z.string(),
  companyId: z.string(),
  userId: z.string(),
  status: z.string(),
});

export type CompanyJoinRequestResponse = z.infer<
  typeof CompanyJoinRequestResponseSchema
>;

export const PendingCompanyJoinRequestRowSchema = z.object({
  id: z.string(),
  companyId: z.string(),
  userId: z.string(),
  status: z.string(),
  decidedByUserId: z.string().nullable(),
  decidedAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  userEmail: z.string(),
  userFirstName: z.string().nullable(),
  userLastName: z.string().nullable(),
});

export type PendingCompanyJoinRequestRow = z.infer<
  typeof PendingCompanyJoinRequestRowSchema
>;

export const ListPendingCompanyJoinRequestsResponseSchema = z.array(
  PendingCompanyJoinRequestRowSchema,
);

export type ListPendingCompanyJoinRequestsResponse = z.infer<
  typeof ListPendingCompanyJoinRequestsResponseSchema
>;
